import { inject, observer } from 'mobx-react';
import React from 'react';
import { Router } from 'react-router';
import AppWrapper from './AppWrapper';
import Version from './containers/Version/Version';
import PublicRouter from './routers/PublicRouter/PublicRouter';
import { LOCALES } from 'src/constants/main';
import integrationsStore from 'src/mobx/integrationStore';
import { localeStore } from 'src/mobx/localesStore';
import { IMainStore, STORES } from 'src/mobx/mainStore';
import { userStore } from 'src/mobx/userStore';
import { history } from 'src/services/history';
import player from '~/services/audio';
import Messages from '~/view/containers/Messages';
import Toasts from '~/view/containers/Toasts';
import './style.scss';

export interface IRootViewProps {
  localeStore?: IMainStore[STORES.LOCALE_STORE];
}

@observer
class RootView extends React.Component<IRootViewProps, {}> {
  componentDidMount = () => {
    if (localeStore.language === LOCALES.AR) {
      window.document.dir = 'rtl';
    }
    if (window.IS_MOBILE) {
      window.document.body.setAttribute('aria-mobile', 'yes');
    }

    player.soundNotifications();
    // add url change listener to show/hide notification about enabled integration
    history.listen(() => integrationsStore.integrationNotification());
  };

  public render() {
    return (
      <Router history={history}>
        {userStore.isLogin ? (
          <AppWrapper />
        ) : (
          <div className="page-wrapper">
            <PublicRouter />
          </div>
        )}

        <Version />
        <Messages />
        <Toasts />
      </Router>
    );
  }
}

export default inject(STORES.LOCALE_STORE)(RootView);
